// extracted by mini-css-extract-plugin
module.exports = {"type-select":"type-select___Urm1Y","type-input-label":"type-input-label___1Wy1Q"};